// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");

function stringToRepresentationType(representationTypeString) {
  switch (representationTypeString) {
    case "color_code" :
        return "ColorCode";
    default:
      return "SingleColor";
  }
}

function stringFromRepresentationType(representationType) {
  if (representationType === "SingleColor") {
    return "single_color";
  } else {
    return "color_code";
  }
}

function decodeGroup(json) {
  return [
          Json_decode.field("id", Json_decode.string, json),
          Json_decode.field("group", Json_decode.string, json)
        ];
}

function decode(json) {
  return {
          text: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          groups: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("groups", (function (param) {
                                return Json_decode.list(decodeGroup, param);
                              }), param);
                }), json)
        };
}

function empty(param) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: "",
          description: "",
          groups: {
            hd: [
              RandomId$ReactHooksTemplate.toString(RandomId$ReactHooksTemplate.generate()),
              ""
            ],
            tl: /* [] */0
          },
          carryForwardFrom: undefined,
          answerRequirement: "All",
          representationType: "SingleColor",
          translations: /* [] */0,
          answer: undefined
        };
}

function isValidAnswerCount(mandatoryOpt, t) {
  var mandatory = mandatoryOpt !== undefined ? mandatoryOpt : false;
  var answers = t.answer;
  if (answers !== undefined) {
    var answersSize = Belt_List.size(answers);
    var x = t.answerRequirement;
    if (typeof x !== "object") {
      return Belt_List.size(t.groups) === answersSize;
    }
    switch (x.TAG) {
      case "AtLeast" :
          return x._0 <= answersSize;
      case "AtMost" :
          return x._0 >= answersSize;
      case "Exactly" :
          return x._0 === answersSize;
      case "Range" :
          if (x._0 <= answersSize) {
            return x._1 >= answersSize;
          } else {
            return false;
          }
      
    }
  } else {
    return !mandatory;
  }
}

function make(text, description, groups, representationType, uuid) {
  return {
          id: undefined,
          uuid: uuid,
          text: text,
          description: description,
          groups: groups,
          carryForwardFrom: undefined,
          answerRequirement: "All",
          representationType: representationType,
          translations: /* [] */0,
          answer: undefined
        };
}

function answered(t, mandatory) {
  return t.answer !== undefined;
}

function text(t) {
  return t.text;
}

function getTextTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].text;
  } else {
    return t.text;
  }
}

function description(t) {
  return t.description;
}

function getDescriptionTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].description;
  } else {
    return t.description;
  }
}

function getGroupTranslation(t, groupId, groupName, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation === undefined) {
    return groupName;
  }
  var match = List.find_opt((function (param) {
          return param[0] === groupId;
        }), translation[1].groups);
  if (match !== undefined) {
    return match[1];
  } else {
    return groupName;
  }
}

function groups(t) {
  return t.groups;
}

function answerRange(_t) {
  return [
          1,
          5
        ];
}

function carryForwardFrom(t) {
  return t.carryForwardFrom;
}

function representationType(t) {
  return t.representationType;
}

function isColorCoded(t) {
  return t.representationType === "ColorCode";
}

function setText(t, text) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: text,
          description: t.description,
          groups: t.groups,
          carryForwardFrom: t.carryForwardFrom,
          answerRequirement: t.answerRequirement,
          representationType: t.representationType,
          translations: t.translations,
          answer: t.answer
        };
}

function setDescription(t, description) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: description,
          groups: t.groups,
          carryForwardFrom: t.carryForwardFrom,
          answerRequirement: t.answerRequirement,
          representationType: t.representationType,
          translations: t.translations,
          answer: t.answer
        };
}

function setGroups(t, groups) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          groups: groups,
          carryForwardFrom: t.carryForwardFrom,
          answerRequirement: t.answerRequirement,
          representationType: t.representationType,
          translations: t.translations,
          answer: t.answer
        };
}

function setAnswerRequirement(t, answerRequirement) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          groups: t.groups,
          carryForwardFrom: t.carryForwardFrom,
          answerRequirement: answerRequirement,
          representationType: t.representationType,
          translations: t.translations,
          answer: t.answer
        };
}

function answerRequirement(t) {
  return t.answerRequirement;
}

function removeGroup(groupId, groups, t) {
  var newSetOfGroups = Belt_List.keep(groups, (function (param) {
          return param[0] !== groupId;
        }));
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          groups: newSetOfGroups,
          carryForwardFrom: t.carryForwardFrom,
          answerRequirement: t.answerRequirement,
          representationType: t.representationType,
          translations: t.translations,
          answer: t.answer
        };
}

function setRepresentationType(t, representationType) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          groups: t.groups,
          carryForwardFrom: t.carryForwardFrom,
          answerRequirement: t.answerRequirement,
          representationType: representationType,
          translations: t.translations,
          answer: t.answer
        };
}

function answer(t) {
  return t.answer;
}

function id(t) {
  return t.id;
}

function uuid(t) {
  return t.uuid;
}

function duplicate(q) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: q.text,
          description: q.description,
          groups: q.groups,
          carryForwardFrom: q.carryForwardFrom,
          answerRequirement: q.answerRequirement,
          representationType: q.representationType,
          translations: q.translations,
          answer: q.answer
        };
}

function overallRating(t) {
  var answerList = t.answer;
  var totalScore = answerList !== undefined ? Belt_List.reduce(Belt_List.map(answerList, (function (param) {
                return param[1];
              })), 0, (function (a, b) {
            return a + b | 0;
          })) : 0;
  var groupCount = Belt_List.length(t.groups);
  var overallRating$1 = totalScore / groupCount;
  return Math.round(overallRating$1) | 0;
}

function setAnswer(t, groupAnswer) {
  var groupId = groupAnswer[0];
  var answers = t.answer;
  if (answers === undefined) {
    return {
            id: t.id,
            uuid: t.uuid,
            text: t.text,
            description: t.description,
            groups: t.groups,
            carryForwardFrom: t.carryForwardFrom,
            answerRequirement: t.answerRequirement,
            representationType: t.representationType,
            translations: t.translations,
            answer: {
              hd: groupAnswer,
              tl: /* [] */0
            }
          };
  }
  var existing = Belt_List.getBy(answers, (function (param) {
          return param[0] === groupId;
        }));
  if (existing !== undefined && existing[1] === groupAnswer[1]) {
    var newAnswers = Belt_List.keep(answers, (function (param) {
            return param[0] !== groupId;
          }));
    return {
            id: t.id,
            uuid: t.uuid,
            text: t.text,
            description: t.description,
            groups: t.groups,
            carryForwardFrom: t.carryForwardFrom,
            answerRequirement: t.answerRequirement,
            representationType: t.representationType,
            translations: t.translations,
            answer: Belt_List.size(newAnswers) > 0 ? newAnswers : undefined
          };
  }
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          groups: t.groups,
          carryForwardFrom: t.carryForwardFrom,
          answerRequirement: t.answerRequirement,
          representationType: t.representationType,
          translations: t.translations,
          answer: Belt_List.concat(Belt_List.keep(answers, (function (x) {
                      return x[0] !== groupId;
                    })), {
                hd: groupAnswer,
                tl: /* [] */0
              })
        };
}

function encodeGroup(param) {
  return {
          hd: [
            "id",
            param[0]
          ],
          tl: {
            hd: [
              "group",
              param[1]
            ],
            tl: /* [] */0
          }
        };
}

function encodeGroups(groups) {
  return Json_encode.list(Json_encode.object_, List.map(encodeGroup, groups));
}

function encodeAnswer(param) {
  return {
          hd: [
            "id",
            param[0]
          ],
          tl: {
            hd: [
              "value",
              param[1]
            ],
            tl: /* [] */0
          }
        };
}

function encodeAnswers(answer) {
  return Json_encode.list(Json_encode.object_, List.map(encodeAnswer, answer));
}

function encodeAnswerRequirement(answerRequirement) {
  if (typeof answerRequirement !== "object") {
    return Json_encode.object_(/* [] */0);
  }
  switch (answerRequirement.TAG) {
    case "AtLeast" :
        return Json_encode.object_({
                    hd: [
                      "min",
                      answerRequirement._0
                    ],
                    tl: /* [] */0
                  });
    case "AtMost" :
        return Json_encode.object_({
                    hd: [
                      "max",
                      answerRequirement._0
                    ],
                    tl: /* [] */0
                  });
    case "Exactly" :
        var count = answerRequirement._0;
        return Json_encode.object_({
                    hd: [
                      "min",
                      count
                    ],
                    tl: {
                      hd: [
                        "max",
                        count
                      ],
                      tl: /* [] */0
                    }
                  });
    case "Range" :
        return Json_encode.object_({
                    hd: [
                      "min",
                      answerRequirement._0
                    ],
                    tl: {
                      hd: [
                        "max",
                        answerRequirement._1
                      ],
                      tl: /* [] */0
                    }
                  });
    
  }
}

function nonEmptyGroups(t) {
  return Belt_List.keep(t.groups, (function (param) {
                return param[1] !== "";
              }));
}

function toJson(withAnswerOpt, t) {
  var withAnswer = withAnswerOpt !== undefined ? withAnswerOpt : false;
  var encodeArray_0 = [
    "id",
    Json_encode.nullable((function (prim) {
            return prim;
          }), t.id)
  ];
  var encodeArray_1 = {
    hd: [
      "text",
      t.text
    ],
    tl: {
      hd: [
        "description",
        t.description
      ],
      tl: {
        hd: [
          "representation_type",
          stringFromRepresentationType(t.representationType)
        ],
        tl: {
          hd: [
            "groups",
            encodeGroups(nonEmptyGroups(t))
          ],
          tl: {
            hd: [
              "answer_requirement",
              encodeAnswerRequirement(t.answerRequirement)
            ],
            tl: /* [] */0
          }
        }
      }
    }
  };
  var encodeArray = {
    hd: encodeArray_0,
    tl: encodeArray_1
  };
  return Json_encode.object_(withAnswer ? ({
                  hd: [
                    "answer",
                    encodeAnswers(Belt_Option.getWithDefault(t.answer, /* [] */0))
                  ],
                  tl: encodeArray
                }) : encodeArray);
}

function decodeGroup$1(json) {
  return [
          Json_decode.field("id", Json_decode.string, json),
          Json_decode.field("group", Json_decode.string, json)
        ];
}

function decodeGroups(json) {
  return Json_decode.field("groups", (function (param) {
                return Json_decode.list(decodeGroup$1, param);
              }), json);
}

function decodeAnswerRequirement(json) {
  var minOpt = Json_decode.optional((function (param) {
          return Json_decode.field("min", Json_decode.$$int, param);
        }), json);
  var maxOpt = Json_decode.optional((function (param) {
          return Json_decode.field("max", Json_decode.$$int, param);
        }), json);
  if (minOpt !== undefined) {
    if (maxOpt !== undefined) {
      if (minOpt === maxOpt) {
        return {
                TAG: "Exactly",
                _0: minOpt
              };
      } else {
        return {
                TAG: "Range",
                _0: minOpt,
                _1: maxOpt
              };
      }
    } else {
      return {
              TAG: "AtLeast",
              _0: minOpt
            };
    }
  } else if (maxOpt !== undefined) {
    return {
            TAG: "AtMost",
            _0: maxOpt
          };
  } else {
    return "All";
  }
}

function decodeTranslation(json) {
  return [
          Json_decode.field("survey_language", (function (param) {
                  return Json_decode.field("name", Json_decode.string, param);
                }), json),
          Json_decode.field("key_string_mapping", decode, json)
        ];
}

function fromJson(json) {
  return {
          id: Json_decode.field("category", (function (param) {
                  return Json_decode.field("id", (function (param) {
                                return Json_decode.optional(Json_decode.$$int, param);
                              }), param);
                }), json),
          uuid: Json_decode.field("uid", RandomId$ReactHooksTemplate.fromJson, json),
          text: Json_decode.field("category", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.field("category", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          groups: Json_decode.field("category", decodeGroups, json),
          carryForwardFrom: Json_decode.field("category", (function (param) {
                  return Json_decode.optional((function (param) {
                                return Json_decode.field("groups_from_uid", RandomId$ReactHooksTemplate.fromJson, param);
                              }), param);
                }), json),
          answerRequirement: Json_decode.field("category", (function (param) {
                  return Json_decode.withDefault("All", (function (param) {
                                return Json_decode.field("answer_requirement", decodeAnswerRequirement, param);
                              }), param);
                }), json),
          representationType: stringToRepresentationType(Json_decode.field("category", (function (param) {
                      return Json_decode.field("representation_type", Json_decode.string, param);
                    }), json)),
          translations: Json_decode.field("translations", (function (param) {
                  return Json_decode.list(decodeTranslation, param);
                }), json),
          answer: undefined
        };
}

var categoryType = "RatingGroup";

exports.categoryType = categoryType;
exports.empty = empty;
exports.text = text;
exports.getTextTranslation = getTextTranslation;
exports.description = description;
exports.getDescriptionTranslation = getDescriptionTranslation;
exports.getGroupTranslation = getGroupTranslation;
exports.groups = groups;
exports.answerRange = answerRange;
exports.carryForwardFrom = carryForwardFrom;
exports.overallRating = overallRating;
exports.make = make;
exports.id = id;
exports.uuid = uuid;
exports.setText = setText;
exports.setDescription = setDescription;
exports.setAnswer = setAnswer;
exports.answered = answered;
exports.answer = answer;
exports.setGroups = setGroups;
exports.removeGroup = removeGroup;
exports.representationType = representationType;
exports.setRepresentationType = setRepresentationType;
exports.toJson = toJson;
exports.fromJson = fromJson;
exports.nonEmptyGroups = nonEmptyGroups;
exports.isColorCoded = isColorCoded;
exports.duplicate = duplicate;
exports.answerRequirement = answerRequirement;
exports.setAnswerRequirement = setAnswerRequirement;
exports.isValidAnswerCount = isValidAnswerCount;
/* RandomId-ReactHooksTemplate Not a pure module */
